import React from "react";

function BottomContent() {
  return (
    <div className="bottom-content">
      <h4>What is a QR Code and why should i use it?</h4>
      <p>
        QR Code is a simple yet efficient method that have galore of use cases,
        especially in these times where everything got to be quick and fast, QR
        Codes can be used for a lot of ways to speed up things. From just
        sharing a contact card to pay & recieve money from your customers, the
        list goes on.
      </p>
      <p>
        At InstantQRCodes, we provide many type of QR codes generation tool,
        those will help you to create instant QR codes that will save you lots
        of time and efforts if you were following traditional communication
        method.
      </p>
      <p>
        We currently support following types of QR Code generation:
        <br />
        - URL (share your website,map,etc to clients &amp; friends easily)
        <br />
        - Texts (Any texts - sky is the limit!)
        <br />
        - Phone (Let them scan to call you.)
        <br />
        - vCard (Share contact cards ultra-fast!)
        <br />
        - WhatsApp (Scan to WhatsApp)
        <br />
        - SMS (Let them SMS you in a flash!)
        <br />- UPI (Recieve money instantly - just need a UPI id)
      </p>
    </div>
  );
}

export default BottomContent;
